import { Button, Container, TextField, Typography } from '@mui/material'
import axios from 'axios'
import React, { useRef, useState } from 'react'
import { Store } from 'react-notifications-component'
import styled from 'styled-components'
import './Newsletter.css'


const NewsletterContainer = styled.div`
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width:1200px;
`

const Newsletter = () => {
    const valueRef = useRef('')
    const [email, setEmail] = useState("")

    const [error, setError] = useState("")


    const isValidEmail = async (email) => {
        console.log("email is", email)
        if(/\S+@\S+\.\S+/.test(email)) {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BACKEND_API_URL}/subscribe`, {body: email})
            .then(
       
                valueRef.current.value="",    
                setError("")
            )
            .catch(e => console.log("error is", e))
        } catch (e) {
            console.log("Error is", e)
        }
        } else {
            setError("Please enter a valid email")
            console.log("email is invalid")
        }
    }

  return (
    <Container id="newsletterContainer">
        <h3 style={{fontWeight:'bold', marginTop:'0'}}>Subscribe to newsletter</h3>
        <TextField
            size="small" 
            onChange={() => setEmail(valueRef.current.value)}
            inputRef={valueRef}
            label="Email"/>
        {error && <span style={{color: 'red', fontWeight: 'bold'}}>{error}</span>}
        <Button variant="contained" color="primary" size="medium" style={{width: '125px', marginTop: '20px'}} onClick={() => isValidEmail(email)}>Subscribe</Button>
    </Container>
  )
}

export default Newsletter